import React, { useState, useRef } from 'react';

/* Cosa fa il pulsante di conferma, detto com'e'. Una lista senza colonna telefono non
   porta numeri in archivio ma porta righe da qualificare: «Importa 0 numeri» sarebbe falso,
   e il pulsante spento avrebbe impedito proprio quel caso (13/10/2026). */
export function etichettaConferma(validi, daQualificare) {
  const n = (x) => (x || 0).toLocaleString('it-IT');
  const numeri = `${n(validi)} ${validi === 1 ? 'numero' : 'numeri'}`;
  const righe = `${n(daQualificare)} ${daQualificare === 1 ? 'riga' : 'righe'} da qualificare`;
  if (!validi && !daQualificare) return 'Niente da importare';
  if (!validi) return `Metti ${n(daQualificare)} ${daQualificare === 1 ? 'riga' : 'righe'} in Da qualificare`;
  if (!daQualificare) return `Importa ${numeri}`;
  return `Importa ${numeri} e ${righe}`;
}

export default function StepAnteprima({ previewData, onConfirm, onBack }) {
  const [showGruppi, setShowGruppi] = useState(true);
  const [showScarti, setShowScarti] = useState(false);

  if (!previewData) return null;

  const {
    valid_count = 0,
    in_attesa_count = 0,
    in_attesa = [],
    skipped = 0,
    duplicates = 0,
    zeri_ripristinati = 0,
    preview = [],
    scarti = [],
    gruppi = [],
    province_distribution = {},
    normalizations = {},
  } = previewData;

  /* Quello che l'import SISTEMA leggendo il file. Scriverlo e' il modo di non fare
     correzioni in silenzio: chi importa deve capire perche' nel file c'era «Liguria» e in
     archivio ci sara' «GENOVA» (13/10/2026). */
  const n = (x) => (x || 0).toLocaleString('it-IT');
  const sistemate = [
    normalizations.provincia_dal_comune > 0 &&
      `provincia ricavata dal comune su ${n(normalizations.provincia_dal_comune)} ${normalizations.provincia_dal_comune === 1 ? 'riga' : 'righe'} (nel file non era una provincia)`,
    normalizations.piva_dal_codice_fiscale > 0 &&
      `partita IVA ricavata dal codice fiscale su ${n(normalizations.piva_dal_codice_fiscale)} ${normalizations.piva_dal_codice_fiscale === 1 ? 'riga' : 'righe'}`,
    zeri_ripristinati > 0 &&
      `zero iniziale rimesso a ${n(zeri_ripristinati)} ${zeri_ripristinati === 1 ? 'numero' : 'numeri'}`,
  ].filter(Boolean);

  const provEntries = Object.entries(province_distribution).sort((a, b) => b[1] - a[1]);
  const totalProv = provEntries.reduce((s, [, v]) => s + v, 0);
  // gruppi con piu' di un numero in cima
  const gruppiSorted = [...gruppi].sort((a, b) => (b.n || 0) - (a.n || 0));

  // contatori cliccabili: scorri (e apri) il dettaglio corrispondente
  const scartiRef = useRef(null);
  const previewRef = useRef(null);
  const vaiValidi = () => previewRef.current && previewRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  const vaiScarti = () => { setShowScarti(true); scartiRef.current && scartiRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
  const attesaRef = useRef(null);
  const vaiAttesa = () => attesaRef.current && attesaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  // Perche' una riga non puo' entrare in archivio, detto a chi importa.
  const MOTIVO_ATTESA = {
    solo_cellulare: 'Solo cellulare',
    numero_mascherato: 'Numero incompleto nella lista',
    senza_numero: 'Nessun numero nella lista',
  };

  return (
    <div>
      {/* KPI */}
      <div className="card">
        <h2>Riepilogo Anteprima</h2>
        <div className="kpi-grid" style={{ gridTemplateColumns: `repeat(${zeri_ripristinati > 0 ? 5 : 4}, 1fr)`, marginBottom: 0 }}>
          <div className="kpi" style={{ borderLeftColor: '#10b981', cursor: valid_count > 0 ? 'pointer' : 'default' }}
            onClick={valid_count > 0 ? vaiValidi : undefined} title={valid_count > 0 ? 'Vedi i numeri validi' : undefined}>
            <div className="label">Numeri fissi validi</div>
            <div className="value" style={{ color: '#059669' }}>{valid_count}</div>
            {valid_count > 0 && <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 2 }}>tocca per dettagli</div>}
          </div>
          <div className="kpi" style={{ borderLeftColor: '#06b6d4', cursor: in_attesa_count > 0 ? 'pointer' : 'default' }}
            onClick={in_attesa_count > 0 ? vaiAttesa : undefined}
            title={in_attesa_count > 0 ? 'Vedi le righe da qualificare' : undefined}>
            <div className="label">Da qualificare</div>
            <div className="value" style={{ color: '#0891b2' }}>{in_attesa_count}</div>
            {in_attesa_count > 0 && <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 2 }}>tocca per dettagli</div>}
          </div>
          <div className="kpi" style={{ borderLeftColor: '#f59e0b', cursor: skipped > 0 ? 'pointer' : 'default' }}
            onClick={skipped > 0 ? vaiScarti : undefined} title={skipped > 0 ? 'Vedi gli scarti' : undefined}>
            <div className="label">Scartati</div>
            <div className="value" style={{ color: '#d97706' }}>{skipped}</div>
            {skipped > 0 && <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 2 }}>tocca per dettagli</div>}
          </div>
          <div className="kpi" style={{ borderLeftColor: '#ef4444' }}>
            <div className="label">Duplicati</div>
            <div className="value" style={{ color: '#dc2626' }}>{duplicates}</div>
          </div>
          {zeri_ripristinati > 0 && (
            <div className="kpi" style={{ borderLeftColor: '#0ea5e9' }}>
              <div className="label">Zeri ripristinati</div>
              <div className="value" style={{ color: '#0284c7' }}>{zeri_ripristinati}</div>
            </div>
          )}
        </div>
        {sistemate.length > 0 && (
          <div style={{ marginTop: 14, padding: '10px 14px', background: 'var(--surface-2)',
                        borderRadius: 8, fontSize: 13 }}>
            <strong>Cosa ho sistemato leggendo il file</strong>
            <ul style={{ margin: '6px 0 0', paddingLeft: 18, color: 'var(--muted)' }}>
              {sistemate.map((t, i) => <li key={i} style={{ marginTop: 2 }}>{t}</li>)}
            </ul>
          </div>
        )}
      </div>

      {/* Gruppi per ragione sociale */}
      {gruppiSorted.length > 0 && (
        <div className="card">
          <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            onClick={() => setShowGruppi(v => !v)}>
            <h2 style={{ margin: 0 }}>Aziende ({gruppiSorted.length}) — numeri per ragione sociale</h2>
            <span style={{ fontSize: 18, color: '#64748b' }}>{showGruppi ? '▲' : '▼'}</span>
          </div>
          {showGruppi && (
            <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 360, overflowY: 'auto' }}>
              {gruppiSorted.slice(0, 200).map((g, i) => (
                <div key={i} style={{ border: '1px solid #eef2f7', borderRadius: 8, padding: '8px 12px' }}>
                  <div style={{ fontSize: 13, fontWeight: 700 }}>
                    {g.ragione_sociale || '(senza ragione sociale)'}
                    {g.partita_iva && <span style={{ fontWeight: 400, color: '#94a3b8', marginLeft: 8, fontSize: 12 }}>P.IVA {g.partita_iva}</span>}
                    <span style={{ fontWeight: 400, color: g.n > 1 ? '#b45309' : '#94a3b8', marginLeft: 8, fontSize: 12 }}>
                      {g.n} {g.n === 1 ? 'numero' : 'numeri'}
                    </span>
                  </div>
                  <div style={{ marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {(g.numeri || []).map((num, j) => (
                      <span key={j} style={{ fontFamily: 'monospace', fontSize: 12, background: '#f1f5f9', color: '#334155', padding: '2px 8px', borderRadius: 6 }}>{num}</span>
                    ))}
                  </div>
                </div>
              ))}
              {gruppiSorted.length > 200 && <div style={{ fontSize: 12, color: '#94a3b8' }}>+{gruppiSorted.length - 200} altre</div>}
            </div>
          )}
        </div>
      )}

      {/* Province */}
      {provEntries.length > 0 && (
        <div className="card">
          <h2>Distribuzione Province</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {provEntries.slice(0, 20).map(([prov, count]) => (
              <div key={prov} style={{ padding: '4px 12px', background: '#eff6ff', borderRadius: 20, fontSize: 12,
                fontWeight: 600, color: '#1e40af', border: '1px solid #bfdbfe' }}>
                {prov}: {count}
                {totalProv > 0 && <span style={{ fontWeight: 400, color: '#64748b', marginLeft: 4 }}>({Math.round(count / totalProv * 100)}%)</span>}
              </div>
            ))}
            {provEntries.length > 20 && <div style={{ fontSize: 12, color: '#94a3b8', alignSelf: 'center' }}>+{provEntries.length - 20} altre</div>}
          </div>
        </div>
      )}

      {/* Scarti con motivo */}
      {in_attesa_count > 0 && (
        <div className="card" ref={attesaRef}>
          <h2>Da qualificare · {in_attesa_count}</h2>
          <p style={{ color: '#64748b', fontSize: 13.5, marginTop: -6 }}>
            Righe senza un numero di rete fissa: il 456 non le puo' verificare. Restano fuori
            dall'archivio e vanno all'agente, che cerca l'azienda e con lei il numero fisso.
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table className="tabella">
              <thead>
                <tr><th>Ragione sociale</th><th>Comune</th><th>Numero nella lista</th><th>Motivo</th></tr>
              </thead>
              <tbody>
                {in_attesa.map((r, i) => (
                  <tr key={i}>
                    <td>{r.ragione_sociale || '—'}</td>
                    <td>{r.comune || '—'}</td>
                    <td>{(r.cellulari || []).concat(r.mascherati || []).join(', ') || '—'}</td>
                    <td>{MOTIVO_ATTESA[r.motivo] || r.motivo}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {in_attesa_count > in_attesa.length && (
            <p style={{ color: '#94a3b8', fontSize: 12.5 }}>
              Mostrate le prime {in_attesa.length} di {in_attesa_count}.
            </p>
          )}
        </div>
      )}

      {scarti.length > 0 && (
        <div className="card" ref={scartiRef}>
          <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            onClick={() => setShowScarti(v => !v)}>
            <h2 style={{ margin: 0 }}>Scarti ({scarti.length}) — controlla i formati non riconosciuti</h2>
            <span style={{ fontSize: 18, color: '#64748b' }}>{showScarti ? '▲' : '▼'}</span>
          </div>
          {showScarti && (
            <div style={{ marginTop: 12, overflowX: 'auto' }}>
              <table>
                <thead>
                  <tr><th>Valore grezzo</th><th>Motivo</th><th>Ragione sociale</th></tr>
                </thead>
                <tbody>
                  {scarti.slice(0, 200).map((s, i) => (
                    <tr key={i}>
                      <td style={{ fontFamily: 'monospace' }}>{s.raw}</td>
                      <td style={{ color: '#ef4444' }}>{s.motivo}</td>
                      <td>{s.ragione_sociale || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Anteprima numeri */}
      <div className="card" ref={previewRef}>
        <h2>Anteprima numeri ({preview.length})</h2>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr><th>Numero</th><th>Ragione Sociale</th><th>Partita IVA</th><th>Provincia</th></tr>
            </thead>
            <tbody>
              {preview.map((row, i) => (
                <tr key={i}>
                  <td style={{ fontFamily: 'monospace' }}>{row.numero_pulito}</td>
                  <td>{row.ragione_sociale || '—'}</td>
                  <td style={{ fontFamily: 'monospace' }}>{row.partita_iva || '—'}</td>
                  {/* la provincia che il record AVRA': il prefisso e' un'altra cosa, e
                      mostrarlo qui faceva leggere IMPERIA dove sarebbe nato GENOVA */}
                  <td>{row.provincia || row.provincia_prefisso || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card" style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <button className="btn btn-secondary" onClick={onBack}>← Indietro</button>
        <button className="btn btn-success" onClick={onConfirm}
          disabled={valid_count === 0 && in_attesa_count === 0}>
          {etichettaConferma(valid_count, in_attesa_count)}
        </button>
      </div>
    </div>
  );
}
